<template>
  <v-app>
    <v-app-bar absolute color="primary darken-2" dark>
      <v-app-bar-nav-icon class="ml-2">C-Cloud</v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <v-btn icon to="/register">
        <v-icon>mdi-account-plus-outline</v-icon>
      </v-btn>

      <v-btn icon to="/login">
        <v-icon>mdi-login</v-icon>
      </v-btn>
    </v-app-bar>

    <default-view class="mt-15 pt-16" />
    <v-footer color="primary darken-2" padless>
      <v-row justify="center" no-gutters>
        <v-btn
          v-for="link in links"
          :key="link"
          color="white"
          text
          rounded
          class="my-2"
        >
          {{ link }}
        </v-btn>
        <v-col class="primary py-4 text-center white--text" cols="12">
          {{ new Date().getFullYear() }} — <strong>C-Cloud</strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "auth",
  data: () => ({
    links: ["Home", "About Us", "Team", "Services", "Blog", "Contact Us"]
  }),
  components: {
    DefaultView: () => import("./View")
  }
};
</script>
